import Swal from 'sweetalert2';
import { blockchainService } from '../../../../services/blockchainService';

export const iniciarEtapa = async (
  topicoId,
  projectId,
  headers,
  modeloUuid,
  setTopico // 👈 estado do tópico atual
) => {
  const requestData = {
    project_id: projectId,
    topic_id: topicoId,
  };

  const result = await Swal.fire({
    title: 'Confirmação',
    text: 'Deseja realmente iniciar esta etapa?',
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'Sim',
    cancelButtonText: 'Não',
  });

  if (!result.isConfirmed) return;

  try {
    // 🟢 1. Cria os controles (inicia etapa)
    await blockchainService.createFileManagerControls(
      requestData,
      headers
    );

    // 🟢 2. Busca novamente APENAS o tópico
    const response =
      await blockchainService.getTopicItems(
        modeloUuid,
        topicoId,
        projectId,
        headers
      );

    // 🟢 3. Atualiza estado local do tópico
    setTopico(response.topico);

    Swal.fire({
      title: 'Sucesso!',
      text: 'Etapa iniciada com sucesso!',
      icon: 'success',
      confirmButtonText: 'OK',
    });

  } catch (error) {
    console.error('❌ Erro ao iniciar etapa:', error);

    Swal.fire({
      title: 'Erro!',
      text: 'Etapa já iniciada ou erro ao processar.',
      icon: 'error',
      confirmButtonText: 'OK',
    });
  }
};
